import { StyleSheet } from 'react-native';

import { AppColors } from '../services/styles';
import { Paragraph, ParagraphSizes } from './paragraph';

const WarningText = (props) =>
  props.children ? (
    <Paragraph
      size={ParagraphSizes.SMALL}
      style={[styles.warningText, props.style || {}]}
    >
      {props.children}
    </Paragraph>
  ) : null;

const styles = StyleSheet.create({
  warningText: {
    color: AppColors.errorText,
    paddingTop: 20,
    paddingBottom: 20
  }
});

export { WarningText };
